
enum Types {
    SET = 'set-disposition',
    RESET = 'reset-disposition',
}

interface Action<T, P = any> {
    type: T,
    payload: P,
}

const initial: any = {
    incomingcall: false,
};

export const dispositionstate = (context: any) => {
    const { log } = context;
    return (state: typeof initial = initial, action: Action<Types>) => {
        if(action.type === "set-disposition")
        {
        // console.debug (
        //     'hotkeys', action,
        // );
        log.debug(
            'dispositionstate',
            'action',{
                action
            }
        );
        }
        let updated = state;
        const { type, payload } = action;

        switch (type) {
            case Types.SET:
                updated = {
                    ...updated,
                    ...payload,
                };
                break;

            case Types.RESET:
                updated = initial;
                break;
        }
        return updated;
    }
}
